import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function SearchIcon({ fill = "black", width = 25, height = 25, ...rest }) {
  return (
    <svg width={width} height={height} viewBox="0 0 25 25" fill={fill} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M23.911 24.9999L25 23.9109L1.08899 7.90945e-05L-1.01301e-06 1.08906L23.911 24.9999Z" fill={fill} />
      <path d="M1.08899 25.0001L25 1.08936L23.911 0.000377415L-4.6081e-06 23.9111L1.08899 25.0001Z" fill={fill} />
    </svg>
  );
}
